import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer__inner">
        <div>
          <span className="site-footer__name">Usman&rsquo;s Garden</span>
          <p className="site-footer__blurb">
            Everything grown in one South of England garden - plant records,
            month-by-month notes and photographs.
          </p>
        </div>

        <nav className="site-footer__col" aria-label="Footer">
          <h2 className="site-footer__heading">Explore</h2>
          <Link to="/">Plants</Link>
          <Link to="/guides">Growing guides</Link>
          <Link to="/about">About</Link>
        </nav>

        <div className="site-footer__col">
          <h2 className="site-footer__heading">Reference</h2>
          <a href="https://www.rhs.org.uk/" target="_blank" rel="noopener noreferrer">RHS</a>
          <a href="https://premierseedsdirect.com/" target="_blank" rel="noopener noreferrer">Premier Seeds Direct</a>
          <a href="https://open-meteo.com/" target="_blank" rel="noopener noreferrer">Open-Meteo</a>
        </div>
      </div>

      <div className="site-footer__base">
        <div className="site-footer__base-inner">
          <span>&copy; {year} Usman Mehr</span>
          <span>Built and maintained by Usman Mehr</span>
        </div>
      </div>
    </footer>
  );
}
